import { apiRequest } from 'utils/request'

export const getCompatibilityModules = () =>
  apiRequest('/compatibility-modules')

export const getParameterGroups = () => apiRequest('/parameter-groups')

export const getParameterAddresses = () => apiRequest('/parameter-addresses')
